module.exports = __webpack_public_path__ + "img/07.1266330e.png";